import React, { Component } from 'react';
import CategoryDataItem from './CategoryDataItem';

export default class CategorySelectWrap extends Component {
  render() {
    const {
      resetSelected,
      selectedCategoryIndex,
      setSelectedCategoryIndex,
      updateShowResultStatus,
      CategoryData
    } = this.props;
    return (
      <div className="category__wrap">
        {
          !CategoryData ? null :
            CategoryData.map((item, index) => {
              return(
                <CategoryDataItem
                  selectedCategoryIndex={selectedCategoryIndex}
                  setSelectedCategoryIndex={setSelectedCategoryIndex}
                  updateShowResultStatus={updateShowResultStatus}
                  resetSelected={resetSelected}
                  key={index}
                  itemKey={index}
                  categoryItem={item}
                />
              )
            })
        }
      </div>
    )
  }
}
